import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { number, func } from 'prop-types'

import {
    wallColorsType,
    scenePlanesType,
    wallMarkersType,
    compositionType,
    trackingRoomInfoType,
} from 'models/propTypes'
import { hover } from 'utils/tracker'

import {
    getSelectedComposition,
    getSelectedCompositionId,
    getSelectedCompositionTrackingRoomInfo,
    getSelectedRenderItemId,
} from 'models/compositions/selectors'
import {
    getSelectedSceneWalls,
    getSelectedSceneWallColorsList,
    getSelectedSceneWallMarkers,
} from 'models/scenes/selectors'
import { setWallColor } from 'models/compositions/actions'

import WallPaintPin from 'components/WallPaintPin'

const WallPaintPinContainer = ({
    composition,
    compositionId,
    setColor,
    scenePlanes,
    wallColors,
    wallMarkers,
    wallWidth,
    wallHeight,
    roomInfo,
    selectedRenderItem,
}) => {
    const onPinInteract = useCallback(
        (opening) => {
            // Track opening/closing the color selector
            // Selection is tracked in middleware
            // eslint-disable-next-line i18next/no-literal-string
            const eventname = `DecorateRoom.WallColor.${opening ? 'Open' : 'Dismiss'}`
            hover(eventname, roomInfo)
        },
        [roomInfo],
    )

    if (
        !scenePlanes ||
        !composition ||
        !composition.wallPaint ||
        !scenePlanes ||
        !wallMarkers ||
        wallMarkers.length === 0
    ) {
        return null
    }
    const planeIndices = scenePlanes.map((plane) => plane.planeIdx)
    if (!wallMarkers[planeIndices[0]]) {
        return null
    }

    const wallPaint = composition.wallPaint
    // assuming for now, that all walls are always of the same color
    const singleWallColor = wallPaint[planeIndices[0] || 0] || null
    const singleWallMarker = [
        (100 * wallMarkers[planeIndices[0]][0]) / wallWidth,
        (100 * wallMarkers[planeIndices[0]][1]) / wallHeight,
    ]

    // Hide wall paint pin when a product is selected
    const hidePin = !!selectedRenderItem
    if (hidePin) {
        return null
    }

    return (
        <WallPaintPin
            planeIndices={planeIndices}
            color={singleWallColor}
            compositionId={compositionId}
            setColor={setColor}
            wallMarker={singleWallMarker}
            colorsList={wallColors}
            onPinInteract={onPinInteract}
        />
    )
}

WallPaintPinContainer.defaultProps = {
    composition: null,
    scenePlanes: null,
    wallColors: null,
    wallMarkers: null,
    wallWidth: null,
    wallHeight: null,
    selectedRenderItem: null,
}

WallPaintPinContainer.propTypes = {
    composition: compositionType,
    compositionId: number.isRequired,
    setColor: func.isRequired,
    scenePlanes: scenePlanesType,
    wallColors: wallColorsType,
    wallMarkers: wallMarkersType,
    wallWidth: number,
    wallHeight: number,
    roomInfo: trackingRoomInfoType.isRequired,
    selectedRenderItem: number,
}

const mapStateToProps = (state) => ({
    composition: getSelectedComposition(state),
    compositionId: getSelectedCompositionId(state),
    scenePlanes: getSelectedSceneWalls(state),
    wallColors: getSelectedSceneWallColorsList(state),
    wallMarkers: getSelectedSceneWallMarkers(state),
    roomInfo: getSelectedCompositionTrackingRoomInfo(state),
    selectedRenderItem: getSelectedRenderItemId(state),
})

const mapDispatchToProps = { setColor: setWallColor }

export default connect(mapStateToProps, mapDispatchToProps)(WallPaintPinContainer)
